import { detect } from 'detect-browser';
import { memo } from 'react';

const PdfViewer = ({
    className,
    src,
    title,
}: {
    className: string;
    src: string;
    title: string;
}) => {
    const result = detect();
    if (result?.os === 'iOS' || result?.os === 'Android OS') {
        return (
            <iframe
                className={className}
                src={`https://docs.google.com/viewer?url=${encodeURI(
                    src
                )}&embedded=true`}
                title={title}
            />
        );
    }
    return <iframe className={className} src={src} title={title} />;
};

export default memo(PdfViewer);
